import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 dark:bg-gray-800">
      <div className="relative">
        <div className="w-20 h-20 border-orange-200 border-2 rounded-full"></div>
        <div className="w-20 h-20 border-orange-500 border-t-2 animate-spin rounded-full absolute left-0 top-0"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
